module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/good/group_items-491a1d4c121ff2ddc4e84426f6629341.png";